<h2 mat-dialog-title>Edit team</h2>
<mat-dialog-content>
  <p class="mat-body-2 dialog-lead">
    Updates apply to all {{ data.members.length }} player(s) on this team (captain name and starting hole only).
  </p>
  <mat-progress-bar mode="indeterminate" *ngIf="saving"></mat-progress-bar>
  <form [formGroup]="form" class="dialog-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Team captain</mat-label>
      <input matInput formControlName="teamCaptain" autocomplete="off" />
      <mat-error *ngIf="form.get('teamCaptain')?.hasError('required')">Captain name is required</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Starting hole</mat-label>
      <input matInput formControlName="startingHole" autocomplete="off" />
    </mat-form-field>
  </form>
  <p class="error-text" *ngIf="errorMessage">{{ errorMessage }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving">Save</button>
</mat-dialog-actions>
